module.exports = __webpack_public_path__ + "img/商超-热敏.e3f7a976.jpg";